const DATE_FILTER_DIVIDER = "#CBD5E1";

export const getDateFilterColors = (theme) => ({
  border: DATE_FILTER_DIVIDER,
  iconColor: theme.palette.text.secondary,
  inputBackground: theme.palette.background.default,
});
export const getDateFilterPickerSlotProps = (theme, slotProps = {}) => {
  const { iconColor } = getDateFilterColors(theme);

  const selectedState = {
    backgroundColor: `${iconColor} !important`,
    color: "#fff !important",
  };

  const popupSx = {
    "& .MuiPickersYear-yearButton.Mui-selected": selectedState,
    "& .MuiPickersYear-yearButton.Mui-selected:hover": selectedState,
    "& .MuiPickersYear-yearButton.Mui-selected:focus": selectedState,
    "& .MuiPickersMonth-monthButton.Mui-selected": selectedState,
    "& .MuiPickersMonth-monthButton.Mui-selected:hover": selectedState,
    "& .MuiPickersMonth-monthButton.Mui-selected:focus": selectedState,
    "& .MuiPickersDay-root.Mui-selected": selectedState,
    "& .MuiPickersDay-root.Mui-selected:hover": selectedState,
    "& .MuiPickersDay-root.Mui-selected:focus": selectedState,
    "& .MuiDialogActions-root .MuiButton-root": { color: iconColor },
    "& .MuiPickersCalendarHeader-root .MuiIconButton-root": { color: iconColor },
    "& .MuiPickersArrowSwitcher-root .MuiIconButton-root": { color: iconColor },
  };

  return {
    ...slotProps,
    day: {
      ...slotProps.day,
      sx: {
        "&.MuiPickersDay-root.Mui-selected": selectedState,
        "&.MuiPickersDay-root.Mui-selected:hover": selectedState,
        "&.MuiPickersDay-root.Mui-selected:focus": selectedState,
        ...slotProps.day?.sx,
      },
    },
    layout: {
      ...slotProps.layout,
      sx: { ...popupSx, ...slotProps.layout?.sx },
    },
    desktopPaper: {
      ...slotProps.desktopPaper,
      sx: { ...popupSx, ...slotProps.desktopPaper?.sx },
    },
    mobilePaper: {
      ...slotProps.mobilePaper,
      sx: { ...popupSx, ...slotProps.mobilePaper?.sx },
    },
    openPickerIcon: {
      ...slotProps.openPickerIcon,
      sx: { color: iconColor, ...slotProps.openPickerIcon?.sx },
    },
    actionBar: {
      ...slotProps.actionBar,
      sx: {
        "& .MuiButton-root": { color: iconColor },
        ...slotProps.actionBar?.sx,
      },
    },
    textField: slotProps.textField,
  };
};

export const getDateFilterButtonSx = (theme) => {
  const { iconColor } = getDateFilterColors(theme);

  return {
    backgroundColor: iconColor,
    color: "#fff",
    "&:hover": {
      backgroundColor: iconColor,
      opacity: 0.9,
    },
  };
};

export const getDateFilterOutlinedButtonSx = (theme) => {
  const { border, iconColor } = getDateFilterColors(theme);

  return {
    color: iconColor,
    borderColor: border,
    "&:hover": {
      borderColor: border,
      backgroundColor: "transparent",
      opacity: 0.9,
    },
  };
};
